//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            showNext: false,
            index: 0,
            slides: [
                {
                    person: '/images/game/w1d2/geology/geology_woman_2.png',
                    text: this.$lang.get('w1d2.game2.earth', {br: '\n'}),
                    image: '/images/game/w1d2/geology/geology_slide_1.png',
                },
                {
                    person: '/images/game/w1d2/geology/geology_woman_3.png',
                    text: this.$lang.get('w1d2.game2.stones', {br: '\n'}),
                    image: '/images/game/w1d2/geology/geology_slide_2.png',
                },
                {
                    person: '/images/game/w1d2/geology/geology_woman_2.png',
                    text: this.$lang.get('w1d2.game2.maps', {br: '\n'}),
                    image: '/images/game/w1d2/geology/geology_slide_3.png',
                },
                {
                    person: '/images/game/w1d2/geology/geology_woman_4.png',
                    text: this.$lang.get('w1d2.game2.vulcano', {br: '\n'}),
                    image: '/images/game/w1d2/geology/geology_slide_4.png',
                }
            ]
        };
    },

    computed: {
        result () {
            return this.$game.getMediaResult(this.slides.length);
        }
    },

    methods: {
        nextSlide () {
            this.index++;

            if (this.index === this.slides.length - 1 && !this.showNext) {
                this.showNext = true;
            }
        },
        prevSlide () {
            this.index--;
        }
    }
};
